<template>
    <Modal size="m" :onClose="handleClose" :onCloseOutside="false">
        <div class="welcome-sembonus">
            <Illustration
                class="welcome-sembonus-illustration"
                :data="{ type: 'Success3', primary: 'black', accent: 'purple' }" />
            <div class="welcome-sembonus-content">
                <h2 class="welcome-sembonus-title">
                    {{ t({ key: 'sembonus.welcome_to_sembonus' }) }}
                </h2>
                <p class="welcome-sembonus-text">
                    {{ t({ key: 'sembonus.you_can_now_start_collect_stamps' }) }}
                </p>
            </div>
            <Button :onClick="handleClose" color="black">
                {{ t({ key: 'sembonus.start_collecting_stamps' }) }}
            </Button>
        </div>
    </Modal>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { useStore } from '@/store';
    import { defineComponent } from 'vue';
    import { sanitize } from '@shared/utils/sanitize';
    import Modal from '@ui/components/Modal/Modal.vue';
    import Illustration from '@ui/components/Illustration/Illustration.vue';
    import Button from '@ui/components/Button/Button.vue';

    export default defineComponent({
        name: 'WelcomeSembonus',
        methods: { t, sanitize },
        components: { Modal, Button, Illustration },
        setup() {
            const store = useStore();

            function handleClose() {
                store.dispatch('general/setModal', null);
            }

            return { handleClose };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'WelcomeSembonus.scss';
</style>
